<template>
    <div>
        <div class="outTopBox">
            <top-bread :bread="bread">
                <span slot="second">酒店管理</span>
                <span slot="third">使用中酒店</span>
            </top-bread>
            <fold-top-search @fold="getFoldMeth"></fold-top-search>
        </div>
        <el-card class="box-card searchCard" v-if="fold.showSearch">
            <top-search
                    :topSearchShow="topSearchShow"
                    @condition="getCondition"
                    :topSearchSave="topSearchSave" :allLoadingState="allLoadingState">
            </top-search>
        </el-card>
        <screen-type @screenTypeSearch="screenTypeSearch" v-if="auth.type!=='group'"
                            :showPartProp="showPart" :allLoadingState="allLoadingState">
        </screen-type>
        <!--ssp地图-->
        <div class="mainBox" v-if="showFunModel('运营酒店地图') || showFunModel('数据概览') || showFunModel('排行榜')">
            <div class="lineContent chart">
                <el-row :gutter="20" class="rowBox outBox">
                    <el-col :span="15" class="mapCol" v-if="showFunModel('运营酒店地图')">
                        <!--<map-chart :location="map.location" v-loading="table.loading"></map-chart>-->
                        <div id="map" style="width:100%">
                            <baidu-map class="baiduMap" v-loading="map.mapLoading"
                                       :center="map.centerLabel"
                                       :scroll-wheel-zoom="true"
                                       @zoomend="zoomMeth"
                                       @ready="handler"
                                       @click="clickMeth">
                                <!--<div class="btn" @click="allMeth">市北区</div>-->
                                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                                <bm-overlay :key="index" v-for="(item,index) in map.showList" v-if="map.mapShow"
                                            pane="labelPane"
                                            :class="[{sample: true, active},item.hotel_num?'largeIcon':'smallIcon']"
                                            @draw="draw($event,item.lng,item.lat)"
                                            @mouseover.native="active = true"
                                            @mouseleave.native="active = false"
                                            @click="markerClick(item.area,'','','',item.detailShow,'图例')">
                                    <div style="width:20px;height:25px;background:transparent;position:absolute;top:0;left:5px;cursor:pointer;" @click="markerClick(item.area,item.detailShow,item.lng,item.lat,item.detailText,'littleIcon')" v-if="!item.hotel_num"></div>
                                    <div class="province markerProvince" @click="markerClick(item.area,item.detailShow,item.lng,item.lat,item.detailText,'标题')" v-if="item.hotel_num">{{item.area}}</div>
                                    <div @click="markerClick(item.area,item.detailShow,item.lng,item.lat,item.detailText,'数字')" style="color:#fff;font-size:12px;margin-top:5px;">{{item.hotel_num}}</div>
                                    <bm-info-window
                                            :position="map.infoWindow.position"
                                            :show="map.infoWindow.show"
                                            @click="showDetail">
                                        <p v-text="map.infoWindow.detailText"></p>
                                    </bm-info-window>
                                </bm-overlay>
                            </baidu-map>
                        </div>
                    </el-col>
                    <el-col :span="9" class="detailBox" >
                        <div class="showDataBox whiteBox" v-if="showFunModel('数据概览')">
                            <div class="title blueTitle">数据概览</div>
                            <el-col :span="24" class="showOut" v-loading="dataLoading" >
                                <el-row :gutter="20" class="rowBox vertical borderBox">
                                    <index-four-row-num-unit :span="12" :type="type" :parShowDate="showData.hotelNum" >
                                        <span slot="numTitle" class="noWrap">酒店数量</span>
                                        <span slot="time" class="noWrap">{{showDataTime}}</span>
                                        <span slot="unit" class="noWrap">家</span>
                                    </index-four-row-num-unit>
                                    <index-four-row-num-unit :span="12"  :type="type" :parShowDate="showData.roomNum">
                                        <span slot="numTitle" class="noWrap">房间数量</span>
                                        <span slot="time" class="noWrap">{{showDataTime}}</span>
                                        <span slot="unit" class="noWrap">间</span>
                                    </index-four-row-num-unit>
                                </el-row>
                                <el-row :gutter="20" class="rowBox vertical borderBox" >
                                    <index-four-row-num-unit :span="12"  :type="type" :parShowDate="showData.activeTerminalNum">
                                        <span slot="numTitle" class="noWrap">激活终端数量</span>
                                        <span slot="time" class="noWrap">{{showDataTime}}</span>
                                        <span slot="unit" class="noWrap">台</span>
                                    </index-four-row-num-unit>
                                    <index-four-row-num-unit :span="12" :type="type" :parShowDate="showData.dayActiveRate" parShowUnit="money">
                                        <span slot="numTitle" class="noWrap">日活率</span>
                                        <span slot="time" class="noWrap">{{showDataTime}}</span>
                                        <span slot="unit" class="noWrap">%</span>
                                    </index-four-row-num-unit>
                                </el-row>
                            </el-col>
                        </div>
                        <div class="rankBox whiteBox" ref="rankBox" v-if="showFunModel('排行榜')">
                            <div class="title chartTitle  blueTitle">
                                排行
                            </div>
                            <el-tabs v-model="activeName" class="tabBox centerTab" :stretch="true">
                                <el-tab-pane label="集团品牌排行" name="brand" :key="activeName">
                                    <rank-chart id="brand" :rankChartData="rankData.brand" v-if="activeName==='brand' && rankShow">
                                        <span slot="time">即时</span>
                                        <span slot="unit">家（酒店）</span>
                                    </rank-chart>
                                </el-tab-pane>
                                <el-tab-pane label="客房总量排行" name="roomNum">
                                    <rank-chart id="roomNum" :rankChartData="rankData.roomNum" v-if="activeName==='roomNum' && rankShow">
                                        <span slot="time">即时</span>
                                        <span slot="unit">间（客房）</span>
                                    </rank-chart>
                                </el-tab-pane>
                                <el-tab-pane label="激活终端排行" name="terminal" >
                                    <rank-chart id="terminal" :rankChartData="rankData.terminal" v-if="activeName==='terminal' && rankShow">
                                        <span slot="time">即时</span>
                                        <span slot="unit">台（终端）</span>
                                    </rank-chart>
                                </el-tab-pane>
                                <el-tab-pane label="日活率排行" name="rate">
                                    <rank-chart id="rate" :rankChartData="rankData.rate" v-if="activeName==='rate' && rankShow">
                                        <span slot="time">昨日</span>
                                        <span slot="unit">%</span>
                                    </rank-chart>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <div class="hotelDetailBox" v-if="testShow">
                            <div class="infoBox">
                                <div class="hotelName">{{mapHotelInfo.hotelName}}</div>
                                <div class="numBox">
                                    <div style="margin-bottom:5px;">可投客房数：{{mapHotelInfo.hotelName}}间</div>
                                    <div>可投屏幕数：{{mapHotelInfo.hotelName}}张</div>
                                </div>
                                <div class="address">
                                    <i class="el-icon-location "></i>
                                    {{mapHotelInfo.address}}
                                </div>
                                <div class="price">￥{{mapHotelInfo.priceStart}}元/天~{{mapHotelInfo.priceEnd}}元/天</div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
<!--        <el-card class="box-card chartCard" v-if="showFunModel('数据走势')">-->
	        <el-card class="box-card chartCard" v-if=false>
            <div class="lineContent chart">
                <div class="outChartBox" v-loading="lineLoading">
                    <one-yaxis-line-chart v-if="lineChart.flag && !lineChart.noData" :chart="lineChart"></one-yaxis-line-chart>
                </div>
                <div v-if="lineChart.flag && lineChart.noData" style="line-height:500px;text-align:center">暂无数据</div>
            </div>
        </el-card>
        <el-card class="box-card" v-if="showFunModel('列表')">
            <div class="title chartTitle blueTitle">酒店列表</div>
            <table-list  @showUploadDialog="showUploadDialog"  :table="table" @page="getNewPage" @limit="getNewLimit" v-loading="table.loading" @tableMeth="tableMeth"></table-list>
        </el-card>
         <hotelAllContent ref="hotelAllContent" :query="query"></hotelAllContent>
        <div class="allLoading" v-show="false">{{allLoadingStateCom}}</div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import  qs from 'querystring'
    import GLOBAL from '../../../api/globalVar.js'
      import hotelAllContent from '../content/hotelAllContent'
    import commonMeth from '../../../api/method'
    export default {
         components:{
          
            hotelAllContent
        },
        name: "HotelManOperate",
        data: () => ({
	        accountType:'',
            type:'timeRight',
            bread:{
                level:3,
                firstPath:{path: '/indexShow'},
                thirdPath:{path: '/hotelManOperate'},
                fourthPath:{path: '/hotelManAll'},
            },
            table:{
                tableHeader:[
                    {prop:'hotel',label:'酒店名称',width:'400'},
                    {prop:'hotel_brand',label:'集团K品牌',width:''},
                    {prop:'h_province',label:'省份',width:''},
                    {prop:'h_city',label:'城市',width:''},
                    {prop:'h_county',label:'区县',width:''},
                    {prop:'hotel_room',label:'客房总量（间）',width:''},
                    {prop:'n_connected',label:'激活终端数量（台）',width:''},
                    {prop:'dar',label:'日活率（%）',width:''},
                ],
                tableList:[],
                page:1,
                limit:5,   //当前每页显示多少条
                total:0,
                fromUrl:'hotelManAllUsing',
                name:'hotelManAllUsing',
                otherFromUrl:'hotelManAllUsing',
                option:true,
                loading:true,
                headerStyle:GLOBAL.tableHeaderStyle,
                darText:'日活率（%）',
                test:'22'
            },
            showData:{
                activeTerminalNum: 0,  //激活终端数量
                day_active_rate: 0,      //日活率
                day_active_num: 0,      //日活量
                hotelNum: 0,            //运营酒店数量
                roomNum: 0,             //客房数量
                validActiveTerminalNum: 0,
                dayActiveRate:0, 
            },
            condition:{
                startTime:'2020-01-01',
                endTime:'2020-05-18',
                province:'',
                city:'',
                country:'',
                hotelBrand:'',
                accountManagerId:'',
                screenType:''
            },
            topSearchShow:{ },
            token:'',
            auth:{},
            showLoading:0,
            dataLoading:true,
            fold:{
                showSearch:false,
                foldText:'展开筛选项'
            },
            map:{
                centerLabel:'中国',
                infoWindow: {
                    show: false,
                    contents: '123.41911277834251,41.808487415519224',
                    position:{
                        lng:'',
                        lat:''
                    },
                    detailText:''
                },
                markers: [
                    {
                        lng: 123,
                        lat: 41,
                        name: 'A',
                        info:'',
                        showFlag: false
                    },
                    {
                        lng: 122,
                        lat: 42,
                        name: 'B',
                        info:'',
                        showFlag: false
                    }
                ],
                showList:[],
                provinceList:[
                    {lng:'125.526791',lat:'43.87088',hotel_num:'111',area:'北京市',detailShow:false,detailText:'北京测试1'},
                    {lng:'103.624464',lat:'29.552611',hotel_num:'22',area:'云南省',detailShow:false,detailText:'云南省测试1'},
                    {lng:'130.50001',lat:'32.648863',hotel_num:'33',area:'安徽省',detailShow:false,detailText:'安徽省测试1'},
                ],
                cityListAll:[
                    {lng:'115.961095',lat:'40.282347',num:'33',label:'北京1',detailShow:false},
                    {lng:'116.890734',lat:'39.810434',num:'44',label:'北京2',detailShow:false},
                    {lng:'116.687501',lat:'39.999506',num:'55',label:'北京3',detailShow:false},

                ],
                countyListAll:[
                    {lng:'103.80035',lat:'27.30503',num:'1',label:'第一个',detailText:'神木市滨河大酒店',detailShow:true},
                    {lng:'103.342717',lat:'27.411808',num:'1',label:'第二个',detailText:'谧堂青丘客栈',detailShow:true},
                    {lng:'103.729348',lat:'27.900465',num:'1',label:'第三个',detailText:'台州安颐酒店',detailShow:true},
                    {lng:'103.758991',lat:'25.743407',num:'33',label:'',detail:''},
                    {lng:'103.788312',lat:'25.593866',num:'33',label:'',detail:''},
                    {lng:'103.815333',lat:'25.284809',num:'33',label:'',detail:''},
                ],
                cityListBei:[
                    {lng:'115.961095',lat:'40.282347',num:'33',label:'北京1',detailShow:false},
                    {lng:'116.890734',lat:'39.810434',num:'44',label:'北京2',detailShow:false},
                    {lng:'116.687501',lat:'39.999506',num:'55',label:'北京3',detailShow:false}
                ],
                cityListAn:[   //118.41139,31.425873   117.851278,30.968488     118.396263,29.748963
                    {lng:'118.41139',lat:'31.425873',num:'33',label:'',detailShow:false},
                    {lng:'117.851278',lat:'30.968488',num:'44',label:'',detailShow:false}, //,
                    {lng:'118.396263',lat:'29.748963',num:'55',label:'',detailShow:false},  //,
                ],
                cityListYun:[   //103.725323,27.344827  邵桐
                    {lng:'100.503872',lat:'25.417625',num:'33',label:'昭通市',detailShow:false},
                    {lng:'103.79981',lat:'25.497372',num:'44',label:'曲靖市',detailShow:false}, //曲靖 103.79981,25.497372
                    {lng:'102.550825',lat:'24.357512',num:'55',label:'玉溪市',detailShow:false},  //,玉溪 102.550825,24.357512
                ],
                countyListYunShao:[  //昭通市,   103.342717,27.411808  103.729348,27.900465
                    {lng:'103.80035',lat:'27.30503',num:'1',label:'第一个',detailText:'神木市滨河大酒店',detailShow:true},
                    {lng:'103.342717',lat:'27.411808',num:'1',label:'第二个',detailText:'谧堂青丘客栈',detailShow:true},
                    {lng:'103.729348',lat:'27.900465',num:'1',label:'第三个',detailText:'台州安颐酒店',detailShow:true},
                ],
                countyListYunQu:[  //曲靖,  103.758991,25.743407    103.788312,25.593866  103.815333,25.284809
                    {lng:'103.758991',lat:'25.743407',num:'33',label:'',detail:''},
                    {lng:'103.788312',lat:'25.593866',num:'33',label:'',detail:''},
                    {lng:'103.815333',lat:'25.284809',num:'33',label:'',detail:''},
                ], //102.721863,24.314578
                countyListYunYu:[  //玉溪,  102.639362,24.315105    102.520067,24.283225  102.104116,24.254763
                    {lng:'102.639362',lat:'24.315105',num:'33',label:'',detail:''},
                    {lng:'102.520067',lat:'24.283225',num:'33',label:'',detail:''},
                    {lng:'102.104116',lat:'24.254763',num:'33',label:'',detail:''},
                ], //102.721863,24.314578
                mapShow:true,
                active: false,
                zoom:'',
                mapLoading:true,
                test:false
            },
            active:false,
            belongPartnerCodeAllStr:'',
            allotPartnerCodeAllStr:'',
            activeName: 'brand',
            tabShow:{
            },
            testShow:false,
            mapHotelInfo:{
                hotelName:'麗枫酒店增城宁西店',
                roomNum:'300',
                screenNum:'200',
                address:'广东省广州市增城宁西街道12号首层',
                priceStart:'9.00',
                priceEnd:'18.00',
                date:''
            },
            rankData:{
                brand:{
                    yData:[],
                    seriesData:[]
                },
                roomNum:{
                    yData:[],
                    seriesData:[]
                },
                terminal:{
                    yData:[],
                    seriesData:[]
                },
                rate:{
                    yData:[],
                    seriesData:[]
                },
            },
            rankShow:false,
            funArr:[],
            allData:{},
            mapColSpan:22,
            dataColSpan:2,
            treeLoading:true,
            topSearchSave:{},
            lineLoading:false,
            lineChart:{
                id:'lineChart',
                showTitle:true,
                flag:false,
                noData:false,
                fromUrl:'hotelMan',
                lineLoading:false,
                option:{
                    legend:[],
                    xData:[],
                    series:[
                        // {
                        //     name: '激活终端数量',
                        //     type: 'line',
                        //     smooth:true,
                        //     itemStyle: {
                        //         normal: {
                        //             color: GLOBAL.chartColor[1], //改变折线点的颜色
                        //             lineStyle: {
                        //                 color: GLOBAL.chartColor[1]//改变折线颜色
                        //             }
                        //         }
                        //     },
                        //     data: []
                        // },
                    ]
                }
            },
            showPart:{
                self:true,
                other:true,
            },
            allLoadingState:false,
            query:{},
        }),
        methods:{
            showUploadDialog(val){
                this.query = val;
                this.$refs.hotelAllContent.contentShow=true;
                this.$refs.hotelAllContent.type="detail";
                if (this.query.id!==''){
                    this.$http.get(this.global.view, {
                        params: {
                            token: this.token,
                            id: this.query.id,
                        },
                    }).then((res) => {
                        if (res.data.code === 100000) {
                            this.query.hotel_use_state= res.data.data.hotel_use_state;
                            this.$refs.hotelAllContent.getHotelDetail(this.query);
                        }
                    });
                }else{
                    this.$refs.hotelAllContent.getHotelDetail(this.query);
                }
                this.$refs.hotelAllContent.getHotalContentList(this.query.hotel_contract);
            },
            SetConditionScreentype(){
                var param = qs.stringify({
                    token: this.token,
                });
                this.$http.post(this.global.getIndexHeader, param).then((res) => {
                    var code = res.data.code;
                    if (code === 100000) {
                        this.accountType = res.data.data.accountType;
                    } else {
                    }
                    switch (this.accountType) {
                        case 1:
                            this.condition.screenType='self'
                            break
                        case 2:
                            this.condition.screenType='self'
                            break
	                    case 3:
	                        this.condition.screenType=''
                        case 5:
                            this.condition.screenType='belong'
                            break
                        case 6:
                            this.condition.screenType='belong'

                    }
                });
            },
            tableMeth(orderVal,type){
                this.table.loading=true;
                var sortStr='';
                var orderStr='';
                var params={};

                if(orderVal){
                    if(orderVal.prop.indexOf('_text')!==-1){
                        var index=orderVal.prop.indexOf('_text');
                        sortStr=orderVal.prop.substring(0,index);
                    }else{
                        sortStr=orderVal.prop;
                    }
                    orderVal.order==='ascending'?orderStr='ASC':orderStr='DESC';
                }else{
                    sortStr='id';
                    orderStr='DESC';
                }
                params={
                    token:sessionStorage.getItem('token'),
                    in_use:1,
                    is_get_location:1,
                    page:this.table.page,
                    per_page:this.table.limit,
                    hotel_brand:this.condition.hotel_brand,
                    hotelBrand:this.condition.hotel_brand,
                    citycode:this.condition.citycode,
                     check_state:this.condition.acceptanceType,
                    province:this.condition.provinceLabel,
                    city:this.condition.cityLabel,
                    county:this.condition.countyLabel,
                    accountManagerId:this.condition.BD,
                    hotel_use_state:this.condition.hotel_use_state,
                    partner_id:this.condition.partner_id,
                    keyword:this.condition.keyword,
                    startTime:this.condition.startTime,
                    endTime:this.condition.endTime,
                    belongPartnerCode: this.condition.belongPartnerCode,
                    allotPartnerCode: this.condition.allotPartnerCode,
                    sort:sortStr,
                    order:orderStr,
                    refresh: false,
	                screenType:this.condition.screenType
                };
                this.$http.get(this.global.search,{
                    params:params
                }).then(res=>{
                    if(type==='mounted'){
                        this.table.page=sessionStorage.getItem('filterPage')*1;
                    }
                    if(res.data.code===100000){
                        var tableData=res.data.data;
                        this.table.tableList=tableData.items;
                        this.map.location=tableData.location;
                        this.map.flag=true;
                        this.table.total=parseInt(tableData.total);
                    }else{
                        this.$message.error(res.data.msg);
                    }
                    this.table.loading=false;
                }).catch(()=>{
                    this.table.loading=false;
                    this.$message.error('访问失败');
                })
            },
            tableMethfrist(orderVal,type){
                this.table.loading=true;
                var sortStr='';
                var orderStr='';
                var params={};

                if(orderVal){
                    if(orderVal.prop.indexOf('_text')!==-1){
                        var index=orderVal.prop.indexOf('_text');
                        sortStr=orderVal.prop.substring(0,index);
                    }else{
                        sortStr=orderVal.prop;
                    }
                    orderVal.order==='ascending'?orderStr='ASC':orderStr='DESC';
                }else{
                    sortStr='id';
                    orderStr='DESC';
                }
                params={
                    token:sessionStorage.getItem('token'),
                    in_use:1,
                    is_get_location:1,
                    page:this.table.page,
                    per_page:this.table.limit,
                    hotel_brand:this.condition.hotel_brand,
                    hotelBrand:this.condition.hotel_brand,
                    citycode:this.condition.citycode,
                     check_state:this.condition.acceptanceType,
                    province:this.condition.provinceLabel,
                    city:this.condition.cityLabel,
                    county:this.condition.countyLabel,
                    accountManagerId:this.condition.BD,
                    hotel_use_state:this.condition.hotel_use_state,
                    partner_id:this.condition.partner_id,
                    keyword:this.condition.keyword,
                    startTime:this.condition.startTime,
                    endTime:this.condition.endTime,
                    belongPartnerCode: this.condition.belongPartnerCode,
                    allotPartnerCode: this.condition.allotPartnerCode,
                    sort:sortStr,
                    order:orderStr,
                    refresh: true,
                };
                this.$http.get(this.global.search,{
                    params:params
                }).then(res=>{
                    if(type==='mounted'){
                        this.table.page=sessionStorage.getItem('filterPage')*1;
                    }
                    if(res.data.code===100000){
                        var tableData=res.data.data;
                        this.table.tableList=tableData.items;
                        this.map.location=tableData.location;
                        this.map.flag=true;
                        this.table.total=parseInt(tableData.total);
                    }else{
                        this.$message.error(res.data.msg);
                    }
                    this.table.loading=false;
                }).catch(()=>{
                    this.table.loading=false;
                    this.$message.error('访问失败');
                })
            },
            showDataMeth(){
                this.dataLoading=true;
                var params={
                    token:sessionStorage.getItem('token'),
                    hotel_brand:this.condition.hotel_brand,
                    hotelBrand:this.condition.hotel_brand,
                    citycode:this.condition.citycode,
                     check_state:this.condition.acceptanceType,
                    province:this.condition.provinceLabel,
                    city:this.condition.cityLabel,
                    county:this.condition.countyLabel,
                    accountManagerId:this.condition.BD,
                    hotel_use_state:'7',
                    partner_id:this.condition.partner_id,
                    keyword:this.condition.keyword,
                    startTime:this.condition.startTime,
                    endTime:this.condition.endTime,
                    belongPartnerCode: this.condition.belongPartnerCode,
                    allotPartnerCode: this.condition.allotPartnerCode,
	                refresh:false,
	                screenType:this.condition.screenType,
                };
                this.$http.post(this.global.getAllHotelDataStatistics,qs.stringify(params)).then(res=>{
                    if(res.data.code===100000){
                        this.showData=res.data.data;
                       
                    }else{
                        this.$message.error(res.data.msg);
                    }
                    this.showLoading++;
                    this.dataLoading=false;
                }).catch(()=>{
                    this.showLoading++;
                    this.$message.error('返回错误');
                    this.dataLoading=false;
                })
            },
            showDataMethfrist(){
                this.dataLoading=true;
                var params={
                    token:sessionStorage.getItem('token'),
                    hotel_brand:this.condition.hotel_brand,
                    hotelBrand:this.condition.hotel_brand,
                    citycode:this.condition.citycode,
                     check_state:this.condition.acceptanceType,
                    province:this.condition.provinceLabel,
                    city:this.condition.cityLabel,
                    county:this.condition.countyLabel,
                    accountManagerId:this.condition.BD,
                    hotel_use_state:'7',
                    partner_id:this.condition.partner_id,
                    keyword:this.condition.keyword,
                    startTime:this.condition.startTime,
                    endTime:this.condition.endTime,
                    belongPartnerCode: this.condition.belongPartnerCode,
                    allotPartnerCode: this.condition.allotPartnerCode,
                    refresh:true,
                };
                this.$http.post(this.global.getAllHotelDataStatistics,qs.stringify(params)).then(res=>{
                    if(res.data.code===100000){
                        this.showData=res.data.data;
                    }else{
                        this.$message.error(res.data.msg);
                    }
                    this.showLoading++;
                    this.dataLoading=false;
                }).catch(()=>{
                    this.showLoading++;
                    this.$message.error('返回错误');
                    this.dataLoading=false;
                })
            },
            getNewPage(newPage){
                this.table.page=newPage;
                this.tableMeth();
            },
            getNewLimit(newLimit){
                this.table.limit=newLimit;
                this.tableMeth();
            },
            getCondition(val,filterPage,filterLimit,type){
                this.topSearchSave=val;
                this.condition.hotel_brand=Array.isArray(val.hotel_brand)?val.hotel_brand.join(','):''; //ka
                if(typeof val.citycode==='string'){
                    this.condition.citycode=val.citycode;
                }else{
                    this.condition.citycode=Array.isArray(val.citycode)?val.citycode.join(','):''; //citycode
                }
                this.condition.provinceLabel=Array.isArray(val.provinceLabel)?val.provinceLabel.join(','):''; //provinceLabel
                this.condition.cityLabel=val.cityLabel;
                this.condition.countyLabel=val.countyLabel;
                   this.condition.acceptanceType =  val.acceptanceType,
                this.condition.hotel_use_state='7';
                this.condition.BD=Array.isArray(val.BD)?val.BD.join(','):'';
                this.condition.partner_id=Array.isArray(val.partner_id)?val.partner_id.join(','):''; //ka
                this.condition.belongPartnerCode=Array.isArray(val.belongPartnerCode)?val.belongPartnerCode.join(','):''; //ka
                this.condition.allotPartnerCode=Array.isArray(val.allotPartnerCode)?val.allotPartnerCode.join(','):''; //ka
                this.condition.startTime = val.startTime;
                this.condition.endTime = val.endTime;
                this.condition.keyword=val.keyword;
                this.table.darText=commonMeth.setTableDarText(this.condition.startTime,this.condition.endTime);
                this.getFilterTableCon(filterPage,filterLimit,type);
                this.tableMeth('',type);
                this.showDataMeth();
                this.getLineChart();
                this.getRankData();
                this.getHotelMapInfo();
            },
            getConditionfrist(val,filterPage,filterLimit,type){
                this.topSearchSave=val;
                this.condition.hotel_brand=Array.isArray(val.hotel_brand)?val.hotel_brand.join(','):''; //ka
                if(typeof val.citycode==='string'){
                    this.condition.citycode=val.citycode;
                }else{
                    this.condition.citycode=Array.isArray(val.citycode)?val.citycode.join(','):''; //citycode
                }
                this.condition.provinceLabel=Array.isArray(val.provinceLabel)?val.provinceLabel.join(','):''; //provinceLabel
                this.condition.cityLabel=val.cityLabel;
                this.condition.countyLabel=val.countyLabel;
                   this.condition.acceptanceType =  val.acceptanceType,
                this.condition.hotel_use_state='7';
                this.condition.BD=Array.isArray(val.BD)?val.BD.join(','):'';
                this.condition.partner_id=Array.isArray(val.partner_id)?val.partner_id.join(','):''; //ka
                this.condition.belongPartnerCode=Array.isArray(val.belongPartnerCode)?val.belongPartnerCode.join(','):''; //ka
                this.condition.allotPartnerCode=Array.isArray(val.allotPartnerCode)?val.allotPartnerCode.join(','):''; //ka
                this.condition.startTime = val.startTime;
                this.condition.endTime = val.endTime;
                this.condition.keyword=val.keyword;
                this.table.darText=commonMeth.setTableDarText(this.condition.startTime,this.condition.endTime);
                this.getFilterTableCon(filterPage,filterLimit,type);
                this.tableMethfrist('',type);
                this.showDataMethfrist();
                this.getLineChartfrist();
                this.getRankDatafrist();
                this.getHotelMapInfo();
            },
            getTopSearchShow(type){
                var auth=JSON.parse(sessionStorage.getItem('auth'));
                var auth_type=auth.type;
                if(auth_type==='channel' || auth_type==='factory'){
                    this.topSearchShow={
                        hotel_brand:true,
                        province:true,
                        city:true,
                        country:true,
                        keyword:true,
                        coopType:true,
                          acceptanceType:true,
                    }
                }else if(auth_type==='screen'){
                    this.topSearchShow={
                        hotel_brand:true,
                        province:true,
                        city:true,
                        country:true,
                        keyword:true,
                        coopType:true,
                          acceptanceType:true,
                    }
                }else if(auth_type==='group'){
                    this.topSearchShow={
                        hotel_brand:true,
                        province:true,
                        city:true,
                        country:true,
                        keyword:true,
                          acceptanceType:true,
                    }
                }
                else if(auth_type==='htrip'){
                    this.topSearchShow={
                        hotel_brand:true,
                        province:true,
                        city:true,
                        country:true,
                        coopType:true,
                        BD:true,
                        keyword:true,
                        coopPartnerType:true,
                        screenType:true,
                          acceptanceType:true,
                    }
                }
                this.topSearchShow.keywordPlaceholder='请输入酒店名称关键词';
            },
            getFoldMeth(val){
                this.fold=val;
            },
            // baidu-map
            markerClick(label,show,lng,lat,detailText,type){
                this.map.centerLabel=label;
                var showInfoWindow=false;
                var zoom=this.map.zoom;
                var areaType='';
                var flag=true;
                if(type!=='littleIcon'){
                    if(zoom<=6){
                        console.log('markerClick-小于6','省',label);
                        this.condition.provinceLabel=label;
                        this.condition.cityLabel='';
                        this.condition.countyLabel='';
                        areaType='province';
                        flag=false;
                    }else if(zoom>=6 && zoom<=10){
                        console.log('markerClick-6到10','市',label);
                        this.condition.cityLabel=label;
                        this.condition.countyLabel='';
                        areaType='city';
                    }else if(zoom>10  ){
                        console.log('markerClick-大于10','县',label);
                        this.condition.countyLabel=label;
                        areaType='county';
                        // this.getHotelMapInfo(areaType,'markerClick');
                    }
                    // else if(zoom>12 ){
                    //     console.log('markerClick','县',label);
                    //     this.condition.countyLabel=label;
                    //     areaType='county';
                    //     // this.getHotelMapInfo(areaType,'markerClick');
                    // }
                }else if(type==='littleIcon'){
                    showInfoWindow=true;
                    this.map.mapLoading=true;
                }
                if(showInfoWindow){
                    // this.map.infoWindow.show=false;
                    this.map.infoWindow.position={lng,lat};
                    this.map.infoWindow.detailText=label;
                    setTimeout(()=>{
                        this.map.mapLoading=false;
                        this.map.infoWindow.show=true;
                    },600);
                }else{
                    if(flag){
                        this.getHotelMapInfo(areaType,'markerClick');
                    }
                    // this.zoomMeth('click')
                }
            },
            showDetail(){
                this.infoWindow.show=true;
            },
            draw ({el, BMap, map},lng,lat) {
                const pixel = map.pointToOverlayPixel(new BMap.Point( lng, lat));
                el.style.left = pixel.x - 60 + 'px';
                el.style.top = pixel.y - 20 + 'px'
            },
            zoomMeth(e,type){
                this.map.infoWindow.detailText='';
                this.map.infoWindow.show=false;
                this.map.mapLoading=true;
                var getViewport=e.target.getViewport();
                var location=getViewport.center.lat+','+getViewport.center.lng;
                var zoom=e.target.getZoom();
                this.map.zoom=zoom;
                if(type!=='click'){
                    this.coordTrans(location).then((res)=>{
                        var obj={};
                        var province=res.province;
                        var city=res.city;
                        var district=res.district;
                        if(zoom<=6){
                            this.condition.provinceLabel='';
                            this.condition.cityLabel='';
                            this.condition.countyLabel='';
                        }else if(zoom>=6 && zoom<=10){
                            this.condition.provinceLabel=province;
                            this.condition.cityLabel='';
                            this.condition.countyLabel='';
                        }else if(zoom>10 && zoom<=12){
                            this.condition.provinceLabel=province;
                            this.condition.cityLabel=city;
                            this.condition.countyLabel='';
                        }else if(zoom>12 ){
                            this.condition.provinceLabel=province;
                            this.condition.cityLabel=city;
                            this.condition.countyLabel=district;
                        }
                        this.getHotelMapInfo();
                    })
                }else{
                    this.getHotelMapInfo();
                }
            },
            coordTrans(location){
                return new Promise((resolve,reject)=>{
                    this.$http.get(this.global.getAddressByCoordinate,{
                        params:{
                            location:location,
                            key:'l1SSg0EvB9jsxk741X4GYDBBokfjVmdV',
                            output:'json',
                            token:this.token
                        }
                    }).then(res=>{
                        if(res.data.code===100000){
                            return resolve(res.data.data);
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    }).catch(()=>{

                    })
                })
            },
            getHotelMapInfo(){
                this.map.mapShow=false;
                this.map.mapLoading=true;
                this.$http.get(this.global.getHotelMapInfo,{
                    params:{
                        token:this.token,
                        hotel_brand:this.condition.hotel_brand,
                        hotelBrand:this.condition.hotel_brand,
                        citycode:this.condition.citycode,
                         check_state:this.condition.acceptanceType,
                        province:this.condition.provinceLabel,
                        city:this.condition.cityLabel,
                        county:this.condition.countyLabel,
                        accountManagerId:this.condition.BD,
                        hotel_use_state:this.condition.hotel_use_state,
                        partner_id:this.condition.partner_id,
                        keyword:this.condition.keyword,
                        belongPartnerCode: this.condition.belongPartnerCode,
                        allotPartnerCode: this.condition.allotPartnerCode,
                    }
                }).then(res=>{
                    if(res.data.code===100000){
                        this.map.showList=res.data.data;
                        this.map.mapShow=true;
                        // console.log('showList',this.map.showList);
                    }else{
                        this.$message.error(res.data.msg);
                    }
                    this.map.mapShow=true;
                    this.map.mapLoading=false;
                    this.map.mapShow=true;
                }).catch(()=>{
                    this.map.mapLoading=false;
                    this.map.mapShow=true;
                })
            },
            handler ({BMap, map}) {
                // 自动获取展示的比例
                var view = map.getViewport(eval(this.map.showList));
                this.map.zoom = view.zoom;
                this.map.center = view.center;
            },
            clickMeth(e){
                console.log('点击',e);
            },
            allMeth(){
                this.centerLabel='中国';
            },
            getRankData(){
                this.rankShow=false;
                var params={
                    token:sessionStorage.getItem('token'),
                    hotel_brand:this.condition.hotel_brand,
                    hotelBrand:this.condition.hotel_brand,
                    citycode:this.condition.citycode,
                    province:this.condition.provinceLabel,
                    city:this.condition.cityLabel,
                     check_state:this.condition.acceptanceType,
                    county:this.condition.countyLabel,
                    accountManagerId:this.condition.BD,
                    hotel_use_state:this.condition.hotel_use_state,
                    partner_id:this.condition.partner_id,
                    keyword:this.condition.keyword,
                    startTime:this.condition.startTime,
                    endTime:this.condition.endTime,
                    belongPartnerCode: this.condition.belongPartnerCode,
                    allotPartnerCode: this.condition.allotPartnerCode,
	                refresh:false,
	                screenType:this.condition.screenType
                };
                    params.screenType=this.condition.screenType
                this.$http.post(this.global.getOperationHotelRankingList,qs.stringify(params)).then(res=>{
                    if(res.data.code===100000){
                        var rankData=res.data.data;
                        this.transData('brand',rankData.brandRanking);
                        this.transData('roomNum',rankData.roomRanking);
                        this.transData('terminal',rankData.terminalRanking);
                        this.transData('rate',rankData.dayActiveRanking);
                        this.rankShow=true;
                    }else{
                        this.$message.error(res.data.data.msg);
                    }
                    this.rankShow=true;
                }).catch((res)=>{
                    this.$message.error('获取失败');
                });
            },
            getRankDatafrist(){
                this.rankShow=false;
                var params={
                    token:sessionStorage.getItem('token'),
                    hotel_brand:this.condition.hotel_brand,
                    hotelBrand:this.condition.hotel_brand,
                    citycode:this.condition.citycode,
                     check_state:this.condition.acceptanceType,
                    province:this.condition.provinceLabel,
                    city:this.condition.cityLabel,
                    county:this.condition.countyLabel,
                    accountManagerId:this.condition.BD,
                    hotel_use_state:this.condition.hotel_use_state,
                    partner_id:this.condition.partner_id,
                    keyword:this.condition.keyword,
                    startTime:this.condition.startTime,
                    endTime:this.condition.endTime,
                    belongPartnerCode: this.condition.belongPartnerCode,
                    allotPartnerCode: this.condition.allotPartnerCode,
                    refresh:true,
                };
                this.$http.post(this.global.getOperationHotelRankingList,qs.stringify(params)).then(res=>{
                    if(res.data.code===100000){
                        var rankData=res.data.data;
                        this.transData('brand',rankData.brandRanking);
                        this.transData('roomNum',rankData.roomRanking);
                        this.transData('terminal',rankData.terminalRanking);
                        this.transData('rate',rankData.dayActiveRanking);
                        this.rankShow=true;
                    }else{
                        this.$message.error(res.data.data.msg);
                    }
                    this.rankShow=true;
                }).catch((res)=>{
                    this.$message.error('获取失败');
                });
            },
            transData(type,val){
                var obj={};
                var yData=[];
                var seriesData=[];
                var rankData=this.rankData;
                obj.yData=yData;
                obj.seriesData=seriesData;
                if(type==='brand'){
                    if(val && val!==''){
                        val.forEach((item,index)=>{
                            yData.push(item.h_group);
                            seriesData.push(item.hotel_num);
                        });
                    }
                    rankData.brand.yData=yData;
                    rankData.brand.seriesData=seriesData;
                }else if(type==='roomNum'){
                    if(val && val!==''){
                        val.forEach((item,index)=>{
                            yData.push(item.h_name);
                            seriesData.push(item.n_hotel_room);
                        });
                    }
                    rankData.roomNum.yData=yData;
                    rankData.roomNum.seriesData=seriesData;
                }else if(type==='terminal'){
                    if(val && val!==''){
                        val.forEach((item,index)=>{
                            yData.push(item.h_name);
                            seriesData.push(item.n_rooms_connected);
                        });
                    }
                    rankData.terminal.yData=yData;
                    rankData.terminal.seriesData=seriesData;
                }else if(type==='rate'){
                    if(val && val!==''){
                        val.forEach((item,index)=>{
                            yData.push(item.hotel);
                            seriesData.push(item.dayActiveRate);
                        });
                    }
                    rankData.rate.yData=yData;
                    rankData.rate.seriesData=seriesData;
                }
            },
            getGroupLevel(){
                return new Promise((resolve,reject)=>{
                    this.$http.get(this.global.groupLevel,{
                        params:{
                            token:this.token
                        }
                    }).then(res=>{
                        if(res.data.code===100000){
                            this.curId=res.data.data.pid[0];
                        }
                        resolve(res.data.data.pid[0]);
                    });
                })
            },
            showFunModelCondition(){
                this.funArr.indexOf('详情')!==-1
                    ? this.table.option=true
                    : this.table.option=true;
                if(this.funArr.indexOf('运营酒店地图')!==-1 && (this.funArr.indexOf('数据统计')===-1 && this.funArr.indexOf('排行榜')===-1)){
                    this.mapColSpan=24;
                }else if(this.funArr.indexOf('运营酒店地图')===-1 && (this.funArr.indexOf('数据统计')!==-1 || this.funArr.indexOf('排行榜')!==-1)){
                    this.mapColSpan=0;
                    this.dataColSpan=10;
                }else if(this.funArr.indexOf('运营酒店地图')!==-1 && (this.funArr.indexOf('数据统计')!==-1 || this.funArr.indexOf('排行榜')!==-1)){
                    this.mapColSpan=14;
                    this.dataColSpan=10;
                }
            },
            getFilterTableCon(filterPage,filterLimit,type){
                if(type==='mounted'){
                    !filterPage || filterPage===''
                        ?this.table.page=1
                        :this.table.page=filterPage;

                    !filterLimit || filterLimit===''
                        ?this.table.limit=5
                        :this.table.limit=filterLimit;
                }else{
                    this.table.page=1;
                    this.table.limit=5;
                    sessionStorage.setItem('filterPage','1');
                    sessionStorage.setItem('filterLimit','5');
                }
            },
            getFilterCon(){
                var filterCon=JSON.parse(sessionStorage.getItem('filterCon'));
                this.topSearchSave=filterCon;
                if(filterCon.screenType){
                    this.condition.screenType=filterCon.screenType.join(',');
                }
                var filterPage=sessionStorage.getItem('filterPage');
                var filterLimit=sessionStorage.getItem('filterLimit');
                this.getCondition(filterCon,filterPage*1,filterLimit*1,'mounted');
            },
            getFilterConfrist(){
                var filterCon=JSON.parse(sessionStorage.getItem('filterCon'));
                this.topSearchSave=filterCon;
                if(filterCon.screenType){
                    this.condition.screenType=filterCon.screenType.join(',');
                }
                var filterPage=sessionStorage.getItem('filterPage');
                var filterLimit=sessionStorage.getItem('filterLimit');
                this.getConditionfrist(filterCon,filterPage*1,filterLimit*1,'mounted');
            },
            getLineChart(){
                this.lineChart.flag=false;
                this.lineLoading=true;
                var params={
                    token:sessionStorage.getItem('token'),
                    hotelBrand:this.condition.hotel_brand,
                    citycode:this.condition.citycode,
                    province:this.condition.provinceLabel,
                    city:this.condition.cityLabel,
                     check_state:this.condition.acceptanceType,
                    county:this.condition.countyLabel,
                    accountManagerId:this.condition.BD,
                    hotel_use_state:this.condition.hotel_use_state,
                    partner_id:this.condition.partner_id,
                    startTime:this.condition.startTime,
                    endTime:this.condition.endTime,
                    keyword:this.condition.keyword,
                    hotelCreateTimeStart:this.condition.hotelCreateTimeStart,
                    hotelCreateTimeEnd:this.condition.hotelCreateTimeEnd,
                    belongPartnerCode: this.condition.belongPartnerCode,
                    allotPartnerCode: this.condition.allotPartnerCode,
	                refresh:false,
	                screenType:this.condition.screenType
                };
                this.$http.post(this.global.getHotelLineLegend,qs.stringify(params)).then(res=>{
                    var code=res.data.code;
                    if(code===100000){
                        var chartData=res.data.data;
                        if(chartData.series){
                            this.lineChart.option.legend=chartData.legend;
                            this.lineChart.option.xData=chartData.xAxis;
                            var dataTransEd=commonMeth.dataTrans(chartData);
                            var arr=[];
                            var index=-1;
                            for(let key in dataTransEd.series){
                                index++;
                                var obj={
                                    name: `${key}`,
                                    type: 'line',
                                    smooth:true,
                                    symbolSize:this.global.symbolSize,   //拐点圆的大小
                                    itemStyle: {
                                        normal: {
                                            color: GLOBAL.chartColor[index], //改变折线点的颜色
                                            lineStyle: {
                                                color: GLOBAL.chartColor[index]//改变折线颜色
                                            }
                                        }
                                    },
                                    data: dataTransEd.series[key]
                                };
                                arr.push(obj);
                            }
                            this.lineChart.option.series=arr;
                        }else{
                            this.lineChart.noData=true;
                        }
                        this.lineChart.flag=true;
                        this.lineLoading=false;
                    }else if(code===100001){
                        this.$message.error('折线图获取失败');
                    }
                    this.lineLoading=false;
                });
            },
            getLineChartfrist(){
                this.lineChart.flag=false;
                this.lineLoading=true;
                var params={
                    token:sessionStorage.getItem('token'),
                    hotelBrand:this.condition.hotel_brand,
                    citycode:this.condition.citycode,
                    province:this.condition.provinceLabel,
                    city:this.condition.cityLabel,
                    county:this.condition.countyLabel,
                     check_state:this.condition.acceptanceType,
                    accountManagerId:this.condition.BD,
                    hotel_use_state:this.condition.hotel_use_state,
                    partner_id:this.condition.partner_id,
                    startTime:this.condition.startTime,
                    endTime:this.condition.endTime,
                    keyword:this.condition.keyword,
                    hotelCreateTimeStart:this.condition.hotelCreateTimeStart,
                    hotelCreateTimeEnd:this.condition.hotelCreateTimeEnd,
                    belongPartnerCode: this.condition.belongPartnerCode,
                    allotPartnerCode: this.condition.allotPartnerCode,
                    refresh:true,
                };
                this.$http.post(this.global.getHotelLineLegend,qs.stringify(params)).then(res=>{
                    var code=res.data.code;
                    if(code===100000){
                        var chartData=res.data.data;
                        if(chartData.series){
                            this.lineChart.option.legend=chartData.legend;
                            this.lineChart.option.xData=chartData.xAxis;
                            var dataTransEd=commonMeth.dataTrans(chartData);
                            var arr=[];
                            var index=-1;
                            for(let key in dataTransEd.series){
                                index++;
                                var obj={
                                    name: `${key}`,
                                    type: 'line',
                                    smooth:true,
                                    symbolSize:this.global.symbolSize,   //拐点圆的大小
                                    itemStyle: {
                                        normal: {
                                            color: GLOBAL.chartColor[index], //改变折线点的颜色
                                            lineStyle: {
                                                color: GLOBAL.chartColor[index]//改变折线颜色
                                            }
                                        }
                                    },
                                    data: dataTransEd.series[key]
                                };
                                arr.push(obj);
                            }
                            this.lineChart.option.series=arr;
                        }else{
                            this.lineChart.noData=true;
                        }
                        this.lineChart.flag=true;
                        this.lineLoading=false;
                    }else if(code===100001){
                        this.$message.error('折线图获取失败');
                    }
                    this.lineLoading=false;
                });
            },
            dataTrans(chartData){
                for(let key in chartData.series){
                    for(let a in chartData.series[key]){
                        if(!chartData.series[key][a]){
                            chartData.series[key][a]=0;
                        }
                    }
                }
                return chartData;
            },
            screenTypeSearch(screenType){
                this.condition.screenType=screenType;
                this.tableMeth();
                this.getLineChart();
                this.showDataMeth();
                this.getRankData();
            },
            getParam(){
                var param={};
                param= {
                    token: this.token,
                    screenType: this.screenType
                }
                // if(this.auth.type==='htrip'){
                //     param={
                //         token:this.token,
                //         screenType:this.screenType
                //     }
                // }else{
                //     param={
                //         token:this.token,
                //     }
                // }
                return param;
            }
        },
        computed:{
            showDataCom(){
                return function(val){
                    if(val===null){
                        return 0;
                    }else{
                        return parseFloat(val).toLocaleString();
                    }
                }
            },
            showDataTime(){
                return '【即时】';
            },
            showFunModel(){
                return function(val){
                    if(this.funArr.indexOf(val)!==-1){
                        return true;
                    }else{
                        return false;
                    }
                }
            },
            twoPointCom(){
                return function(x){
                    !x?x=0:'';
                    var f = parseFloat(x);
                    if (isNaN(f)) {
                        return false;
                    }
                    var f = Math.round(x*100)/100;
                    var s = f.toString();
                    var rs = s.indexOf('.');
                    if (rs < 0) {
                        rs = s.length;
                        s += '.';
                    }
                    while (s.length <= rs + 2) {
                        s += '0';
                    }
                    return s;
                }
            },
            allLoadingStateCom(){
                this.allLoadingState=commonMeth.getAllLoading(this.table.loading,this.lineLoading,this.dataLoading,this.map.mapLoading);
            }
        },
        mounted(){
            this.token=sessionStorage.getItem('token');
            this.auth=JSON.parse(sessionStorage.getItem('auth'));
            this.getTopSearchShow();
            this.getFilterConfrist();
            this.SetConditionScreentype()
            commonMeth.getTreeData(this.table.option).then((res)=>{
                this.funArr=res.funArr;
                this.table.option=res.flag;
            });
        },
        watch:{
            'map.centerLabel'(newVal){
                if(newVal==='中国'){
                    this.map.showList=this.map.provinceList;
                }
            },
            'map.zoom'(newVal){
                // console.log("zoom-11 变化",newVal);
            },
            activeName(newVal){
                this.$nextTick(()=>{
                    // this.$refs[`${newVal}Chart`].echarts.resize()
                })
            },

        },
    }
</script>

<style scoped lang="scss">
    /* 公共样式 开始*/
    .bg-purple {
        /*background: #d3dce6;*/
        background: #fff;
        color:transparent;
    }
    .rowBox{
        margin-top:20px;
        box-sizing: border-box;
    }
    .hotelBrand{
        width:100%;
    }

    .el-table{
        margin-top:15px;
    }
    .pageBox{
        margin-top:15px;
    }
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        /*background: #d3dce6;*/
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
    /* 公共样式 结束*/

    /*折线图*/
    .mapCol{
        /*padding: 0!important;*/
        /*margin-left:10px;*/
    }
    .chart{
        /*min-height:520px;*/
    }
    .lineContent{
        height: 100%;
    }
    .lineContent>.rowBox{
        border-radius:4px;
        padding:20px 10px;
        box-sizing: content-box;
        height:100%;
    }
    .showOut{
        /*height:400px;*/
        /*height:520px;*/
        /*display:flex;*/
        /*flex-direction:column;*/
        /*justify-content:space-around;*/
        .rowBox{
            margin-bottom:0!important;
        }

    }
    .rankBox{
        width:100%;
        /*height:560px;*/
    }
    .detailBox{
        /*max-height:580px;*/
        overflow:auto;
        height:100%;
        /*display:flex;*/
        /*flex-direction:column;*/
        /*overflow:auto;*/
    }
    .showDataBox{
        overflow:hidden;
        margin-bottom:20px;
    }
    .outBox{
        display:flex;
        align-items: center;
        margin-top:0;
        padding:0!important;
    }
    /*地图开始*/
    .baiduMap{
        width:100%;
        height:580px;
    }
    .bm-view {
        width: 100%;
        height: 300px;
    }

    .sample {

        /*line-height: 20px;*/
        /*background: rgba(0,0,0,0.5);*/
        overflow: hidden;
        color: #fff;
        text-align: center;
        padding: 10px;
        position: absolute;
        /*background-image:url(../../assets/img/coordinate.png);*/

        background-repeat: no-repeat;
        background-size:100% 100%;
        display:flex;
        flex-direction: column;
    }
    .largeIcon{
        width: 36px;
        height: 46px;
        background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAABGCAYAAACdW4eSAAAAAXNSR0IArs4c6QAABT9JREFUaAXlm01oHGUYx//P7KaRNKW2qNVIrcUGPAgVNJeA6MHYSjZ7CCSgXvRSEakimA9sD3voR9oIrfUg1oOCWNBAhE2CH+tBPQSkFmwvVlqptVg/DqnFJJg0O6/PM8kss7Mzm5ndmd2Z8b28H8/78f/N8868884HoQEh+4bahhVs56E26YR2GVJTmOfoH6RxLX+E/pSyMAMF3XnvqNpCK3gChMeh0M3xg0phU7VxiBhY4SLXneX4G5XG1zNjdKNaG7+2QED3n1Ktv1xDvwKeZag9LKLFrxBb/VsM/wWLO3P/dky+/Qot2ey+s3WBDoyozf/qeEkHXmVP3O17dC8NCH9owFu3aXhn4hjd9NLEqU5NoAOfqNTiWexjuEPc6VanjkMom+OpfbCtC6cnBqnot3/foJkRtVvp+IAhH/Y7WCD1CT+Qhuenj9F5P/3xrPAeMkPqZVXEd02DFKl8gEWDaPGuHDwZPIR976qW65fxPl9onvNQvWFV+IL1UccuvHD6Rbq13qDrgg7kVPviAib5SPas11lT7IRC20b0T+RI1mXXUBW0L6fa9HkUuHW3aw/RMMxq7eiZytGimxzXczSXU2m1gI9jACls3aJVNPsGPbeAU3xOZtwaRq1ctIpmN12OU7dvRA3qRcObbu2iW04YnBmnCbvACtD+A2rH0jLO88Vns71yLPKEm60bsHvyMF216q04R5eX2f1xhRQy1m4wWCk5XebR7JDaW1T4zFYnltkU4en8OH1uii95VClFusK4aYh7LCzCZHKUQLPD6OVt1kOmIe6xsAiTyVECZcOwWZiU2MpkuDY7qnYVV3ApKYBWjlQanfkxumx4lCGfsRqTlDbZVqcuYSBJcGUsa2zEN+538I37X2wsXaHKKsY/o/iG/y5NzeOxBEOKm0gYZep2SS7hoUtAOxMOKXid/yNQwp2J9ygzikervi5IwkHgTXm7xtuatiTAVGPgdXOjxqtn3e81qg0SCRszikerPiaMhNB6RTAjv6bE3/X2E/X2wqjx/P056kLr1SeMctVN5PbMdnAuafxm6oKtMHFZYdR4jfk2cWQ2IGE0tma9r6vrbLvHZk9K9veZN6lDzlHZieaTQlXBscZmgKY0nKmokJACk82YuvL8MzOEK8y2IyF8JsbV6XHsJCJleFQSbDlpWhMUn1xjw+o5ymRbt+E9juYSBDm3xmQglUA/HKIFXm/GkgIqLMJk8pRApaDjAbCr8ZNpjGssDMJi1V8GKl938M3vfmuFOKaFwf6lShmoQOWPU4HX1RNxBDQ0s3aDwQZQASp2/pxllGG/t9WNfpY1G9odlBrrqEM5MgfUvVjGLN8n3udkj1oZn5e/YgO6pw/Tb07aHD0qFaVBC2EvJ+Ow5MxRGnvcIIXHFVSMnx6nH7U0w/IHEJKPZGBtonHqKF2sps916lob9Y2qLv4cpxC5jzgEMsVfjI3RWatep7QnUGkYOVgfkKK/6tSVCmaQoyZHj49M0x+miQavnjT1e/ao2UA8q1bwJe8CbjfLGhkLJF94nvIyXa26fINK42bB1gopmmsCbQZsPZB1gUrj7LB6VNdRCHsaC6SmoYdv7Wq+W6vZowIqIWzYICBFZ92gYcIGBRkYaBiwQUIGChokbNCQgYMGARsGZCig9cCGBRkaqHTMv1c+wr9XfuV16RFI/sfhSf6d8py0Dzpw/+EFr7BhQwphqKAygMBidYu3RfIVgXADvFkIy5PmeKGDykCusA2CFA0NAXWEbSBkQ0FlsL6Daqe+hNckrbXixNQhuiLpRoT/AIOWxLWQbca7AAAAAElFTkSuQmCC);
    }
    .smallIcon{
        width: 10px;
        height: 12px;
        background-image:url(../../../assets/img/littleIconThree.png);
        /*background-image:url(data:image/png;base64,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);*/
    }
    .largeIcon{
        width: 36px;
        height: 46px;
        background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAABGCAYAAACdW4eSAAAAAXNSR0IArs4c6QAABT9JREFUaAXlm01oHGUYx//P7KaRNKW2qNVIrcUGPAgVNJeA6MHYSjZ7CCSgXvRSEakimA9sD3voR9oIrfUg1oOCWNBAhE2CH+tBPQSkFmwvVlqptVg/DqnFJJg0O6/PM8kss7Mzm5ndmd2Z8b28H8/78f/N8868884HoQEh+4bahhVs56E26YR2GVJTmOfoH6RxLX+E/pSyMAMF3XnvqNpCK3gChMeh0M3xg0phU7VxiBhY4SLXneX4G5XG1zNjdKNaG7+2QED3n1Ktv1xDvwKeZag9LKLFrxBb/VsM/wWLO3P/dky+/Qot2ey+s3WBDoyozf/qeEkHXmVP3O17dC8NCH9owFu3aXhn4hjd9NLEqU5NoAOfqNTiWexjuEPc6VanjkMom+OpfbCtC6cnBqnot3/foJkRtVvp+IAhH/Y7WCD1CT+Qhuenj9F5P/3xrPAeMkPqZVXEd02DFKl8gEWDaPGuHDwZPIR976qW65fxPl9onvNQvWFV+IL1UccuvHD6Rbq13qDrgg7kVPviAib5SPas11lT7IRC20b0T+RI1mXXUBW0L6fa9HkUuHW3aw/RMMxq7eiZytGimxzXczSXU2m1gI9jACls3aJVNPsGPbeAU3xOZtwaRq1ctIpmN12OU7dvRA3qRcObbu2iW04YnBmnCbvACtD+A2rH0jLO88Vns71yLPKEm60bsHvyMF216q04R5eX2f1xhRQy1m4wWCk5XebR7JDaW1T4zFYnltkU4en8OH1uii95VClFusK4aYh7LCzCZHKUQLPD6OVt1kOmIe6xsAiTyVECZcOwWZiU2MpkuDY7qnYVV3ApKYBWjlQanfkxumx4lCGfsRqTlDbZVqcuYSBJcGUsa2zEN+538I37X2wsXaHKKsY/o/iG/y5NzeOxBEOKm0gYZep2SS7hoUtAOxMOKXid/yNQwp2J9ygzikervi5IwkHgTXm7xtuatiTAVGPgdXOjxqtn3e81qg0SCRszikerPiaMhNB6RTAjv6bE3/X2E/X2wqjx/P056kLr1SeMctVN5PbMdnAuafxm6oKtMHFZYdR4jfk2cWQ2IGE0tma9r6vrbLvHZk9K9veZN6lDzlHZieaTQlXBscZmgKY0nKmokJACk82YuvL8MzOEK8y2IyF8JsbV6XHsJCJleFQSbDlpWhMUn1xjw+o5ymRbt+E9juYSBDm3xmQglUA/HKIFXm/GkgIqLMJk8pRApaDjAbCr8ZNpjGssDMJi1V8GKl938M3vfmuFOKaFwf6lShmoQOWPU4HX1RNxBDQ0s3aDwQZQASp2/pxllGG/t9WNfpY1G9odlBrrqEM5MgfUvVjGLN8n3udkj1oZn5e/YgO6pw/Tb07aHD0qFaVBC2EvJ+Ow5MxRGnvcIIXHFVSMnx6nH7U0w/IHEJKPZGBtonHqKF2sps916lob9Y2qLv4cpxC5jzgEMsVfjI3RWatep7QnUGkYOVgfkKK/6tSVCmaQoyZHj49M0x+miQavnjT1e/ao2UA8q1bwJe8CbjfLGhkLJF94nvIyXa26fINK42bB1gopmmsCbQZsPZB1gUrj7LB6VNdRCHsaC6SmoYdv7Wq+W6vZowIqIWzYICBFZ92gYcIGBRkYaBiwQUIGChokbNCQgYMGARsGZCig9cCGBRkaqHTMv1c+wr9XfuV16RFI/sfhSf6d8py0Dzpw/+EFr7BhQwphqKAygMBidYu3RfIVgXADvFkIy5PmeKGDykCusA2CFA0NAXWEbSBkQ0FlsL6Daqe+hNckrbXixNQhuiLpRoT/AIOWxLWQbca7AAAAAElFTkSuQmCC);
    }
    .markerProvince{
        font-size:10px;
        margin-top:8px;
    }
    .sample.active {
        /*background: rgba(0,0,0,0.75);*/
        /*color: #fff;*/
    }
    /*地图结束*/
    /*排行榜开始*/
    #rank{
        width:600px;
        height:500px;
    }
    /*排行榜结束*/

    /*DSP地图信息开始*/
    .rankChart{
        width:100%;
        height:510px;
        background:#e8eaf6;
        display:none;
    }
    .shade.active{

    }

    .hotelName{
        font-size:18px;
        font-weight:600;
    }
    .infoBox .numBox{
        margin:15px 0;
    }
    .hotelImg{
        width:100%;
        height:230px;
        border-radius: 10px;
        margin-bottom:10px;
    }
    .address{
        font-size:16px;
        display:flex;
        align-items: center;
    }
    .address i{
        color:#539efe;
        font-size:20px;
    }
    .price{
        color:red;
        font-size:18px;
        margin-top:10px;
    }
    img,video{
        width:100%;
        height:100%;
    }
    .grayLittle{
        color:#838383;
        font-size:14px;
    }
    /*DSP地图信息结束*/

    .noWrapBox>span{
        white-space:nowrap!important;
    }
    .noWrap{
        white-space:nowrap!important;
    }
    .noPaddingLeft{
        padding-left:0!important;
    }
    .whiteBox{
        background:white;
        padding:20px 10px;
        box-sizing: border-box;
    }
    .mainBox{
        /*padding:20px;*/
        margin-top:20px;
        height:580px;
    }
    .title{
        padding:0 10px;
    }
    .tabBox{
        /*padding-left:10px;*/
        padding:0 10px;
    }
    .flexBox{
        display:flex;
        justify-content: space-between;
    }
    .unit{
        font-size:14px;
        text-align: right;
    }
</style>

























